import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		imageItemCard: {
			display: 'flex',
			width: '100%',
			position: 'relative',
			borderRadius: 0,
			backgroundColor: 'black'
		},
		imageItemCardContent: {
			position: 'absolute',
			bottom: 0,
			width: '100%',
			backgroundColor: 'rgb(255,255,255,0.1)'
		},
		imageItem: {
			backgroundColor: 'black',
			width: '100%',
			height: '100%',
			textAlign: 'center'
		},
		imageItemImg: {
			maxWidth: '100%',
			maxHeight: '100%',
			width: '100%',
			objectFit: 'contain',
			WebkitUserSelect: 'none',
			MozUserSelect: 'none',
			userSelect: 'none',
			WebkitTouchCallout: 'none'
		},
		imageItemPortrait: {
			[theme.breakpoints.down('sm')]: {
				objectFit: 'cover'
			}
		}
	};
});
